/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IEvePastDueNoticeViewProps } from './eve-past-due-notice';
import classnames from 'classnames';

export default (props: IEvePastDueNoticeViewProps) => {
    const _className = 'past-due-notice';
    const {
        config: { noticeText, className }
    } = props;
    return (
        <div className={classnames(`${_className}`, className || '')}>
            <p className={`${_className}__text`}>{noticeText}</p>
        </div>
    );
};
